export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const ADD_LANGUAGE = 'ADD_LANGUAGE';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const REMOVE_LANGUAGE = 'REMOVE_LANGUAGE';
export const CLEAR_LANGUAGE = 'CLEAR_LANGUAGE';
export const CLEAR_LANGUAGES = 'CLEAR_LANGUAGES';
